import script from "./deviceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceInfo.vue?vue&type=script&setup=true&lang=js"

import "./deviceInfo.vue?vue&type=style&index=0&id=236f88ed&lang=scss"

const __exports__ = script;

export default __exports__